// Generated by scripts/translate-catalog.mjs from scripts/translate-catalog.config.json.
// Do not edit: add a language to the config and re-run the script.
import de from './de';
import en from './en';
import fr from './fr';
import es from './es';
import it from './it';
import pt from './pt';
import ro from './ro';
import pl from './pl';
import nl from './nl';
import da from './da';

export * from './languages.generated';
export const CATALOGS = { de, en, fr, es, it, pt, ro, pl, nl, da };
